module.exports = __webpack_public_path__ + "media/images/point/commodity_figure-264a9bf787040336790726ecc5754672.png";